export { FooterPayment } from "./footer-payment";
